import React, { createContext, useContext, useMemo } from 'react'
import { useLocale, type UseLocaleResult } from '../hooks/i18n/useLocale.js'

const LocaleContext = createContext<UseLocaleResult | null>(null)

export function LocaleProvider({ children }: { children: React.ReactNode }) {
  const localeState = useLocale()

  const value = useMemo(() => localeState, [localeState])

  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>
}

export function useLocaleContext(): UseLocaleResult {
  const context = useContext(LocaleContext)
  if (context) return context

  throw new Error('useLocaleContext must be used within LocaleProvider')
}
